<template>
  <div>
    <div class="head">
			<el-breadcrumb style="margin: auto auto auto 10px;" separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>人员在岗在位</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
    <div class="content">
      <div><iframe name="I1" :src="src" height="800px" width="100%"></iframe></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      src: ''
    }
  },
  methods: {

  },
  created() {
    // this.src = this.$route.params.key
    this.src = localStorage.getItem('WHHG')
  }
}
</script>

<style scoped>
.content {
  height: 100%;
}
</style>